import { render, staticRenderFns } from "./polls.vue?vue&type=template&id=61a9c268&"
import script from "./polls.vue?vue&type=script&lang=js&"
export * from "./polls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "polls.vue"
export default component.exports